export var CONFIGURATION_NAME="jutro-app-oidc";